import setRefreshTable from './setRefreshTable'

export default {
  setRefreshTable,
}
